var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEma2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unsure"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.1386 22C44.1386 34.1501 34.2887 44 22.1386 44C9.98856 44 0.138649 34.1501 0.138649 22C0.138649 9.84992 9.98856 0 22.1386 0C34.2887 0 44.1386 9.84992 44.1386 22Z",
    fill: "#FFE14D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66219 22.0862C4.35349 9.93469 9.81023 3.66219 19.1639 0.172913C8.35794 1.5378 0 10.7891 0 21.9995C0 34.1496 9.81887 43.9995 21.9307 43.9995C23.9543 43.9995 25.913 43.7231 27.7734 43.2087C26.8675 43.3229 25.9428 43.4298 25.0071 43.3821C14.9765 42.8702 4.97089 34.2325 4.66219 22.0862Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.8171 21.1371C13.8171 19.058 12.5242 17.3723 10.9298 17.3723C9.33497 17.3723 8.04208 19.058 8.04208 21.1371C8.04208 23.2162 9.33497 24.9018 10.9298 24.9018C12.5247 24.9013 13.8171 23.2157 13.8171 21.1371Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.2038 21.1371C36.2038 19.058 34.9109 17.3723 33.3165 17.3723C31.7217 17.3723 30.4288 19.058 30.4288 21.1371C30.4288 23.2162 31.7217 24.9018 33.3165 24.9018C34.9109 24.9013 36.2038 23.2157 36.2038 21.1371Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.39779 13.8991C5.39779 13.8991 6.15105 13.7782 7.21302 13.5365C8.6485 13.2095 10.6471 12.6614 12.1133 11.8932C14.6641 10.5558 14.0059 14.1428 9.03401 15.1624C4.06265 16.182 4.10682 14.1467 5.39779 13.8991Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.2817 30.869C27.2913 33.3691 24.9081 28.6016 21.991 28.6132C19.074 28.6242 16.7278 33.4105 16.7177 30.91C16.7081 28.4099 17.953 25.2404 21.9781 25.225C25.9048 25.2096 27.2721 28.369 27.2817 30.869Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M37.7605 13.8991C37.7605 13.8991 37.0073 13.7782 35.9453 13.5365C34.5098 13.2095 32.5112 12.6614 31.045 11.8932C28.4943 10.5558 29.1525 14.1428 34.1243 15.1624C39.0957 16.182 39.0515 14.1467 37.7605 13.8991Z",
    fill: "#802E19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEma2);
export default __webpack_public_path__ + "static/media/ema2.01f03680771849235937da7e8083a4f5.svg";
export { ForwardRef as ReactComponent };